var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { RoomService } from '../../../../shared/services/rest/room.service';
import { BuildingService } from '../../../../shared/services/rest/building.service';
import { Building } from '../../../../shared/models/building.model';
import { StringHelper } from '../../../../shared/utils/string-helper';
import { MessageService } from 'src/app/shared/services/message.service';
import { MessageType } from 'src/app/shared/models/message';
import { HttpHelper } from 'src/app/shared/utils/http-helper';
import { TranslateService } from '@ngx-translate/core';
import { BaseInfoComponent } from './base-info.component';
var RoomInfoComponent = /** @class */ (function (_super) {
    __extends(RoomInfoComponent, _super);
    function RoomInfoComponent(room, building, messages, translation) {
        var _this = _super.call(this, building, messages, translation) || this;
        _this.room = room;
        return _this;
    }
    RoomInfoComponent.prototype.ngOnInit = function () {
        if (!this.roomId) {
            throw new Error('The property "roomId" is required on RoomInfoComponent');
        }
        this.loadData();
    };
    Object.defineProperty(RoomInfoComponent.prototype, "id", {
        get: function () {
            return this.roomId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoomInfoComponent.prototype, "typePrefix", {
        get: function () {
            return 'ROOM';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Load data from REST-Api
     *
     * @private
     * @memberof RoomInfoComponent
     */
    RoomInfoComponent.prototype.onLoadData = function () {
        var _this = this;
        // room
        this.room.get(String(this.roomId)).toPromise().then(function (d) {
            var room = d;
            // building
            _this.building.get(String(room.BuildingId)).toPromise().then(function (b) {
                var building = Building.create(b);
                _this.initData(room, building);
                _this.isLoading = false;
            }, function () {
                _this.translation.get('BUILDING_NOT_FOUND', { id: _this.roomId }).subscribe(function (text) { _this.messages.add(text, MessageType.Error); });
                _this.isLoading = false;
            });
        }, function (error) {
            if (error.status === 401) {
                _this.hasNoPermission = true;
            }
            else {
                _this.translation.get('ROOM_NOT_FOUND', { id: _this.roomId }).subscribe(function (text) { _this.messages.add(text, MessageType.Error); });
            }
            _this.isLoading = false;
        });
    };
    /**
     * Map loaded data to model
     *
     * @private
     * @param {Room} room
     * @param {Building} building
     * @memberof RoomInfoComponent
     */
    RoomInfoComponent.prototype.initData = function (room, building) {
        this.data = {
            Ressource: {
                Text: [room.Designation, room.RoomType, room.Description].filter(function (e) { return e; }).join('<br>'),
                NumberPersons: room.NumberPersons
            },
            Infrastructure: room.RoomEquipments.map(function (x) { return x.Designation; }).join(', '),
            Remark: StringHelper.nl2br(StringHelper.stringOrEmpty(room.Memo).trim()),
            RessourceUrl: room.Url ? HttpHelper.ensureHttpPrefix(room.Url) : '',
            Site: building.Site,
            Building: {
                Designation: building.Designation,
                Url: building.Url ? HttpHelper.ensureHttpPrefix(building.Url) : null,
                Floor: room.Floor
            },
            Address: [
                StringHelper.stringOrEmpty(building.Address).trim(),
                (StringHelper.stringOrEmpty(building.Zip) + ' ' + StringHelper.stringOrEmpty(building.Location)).trim()
            ].join('<br>')
        };
        this.initMapLink(building.Address, StringHelper.stringOrEmpty(building.Zip), StringHelper.stringOrEmpty(building.Location));
    };
    return RoomInfoComponent;
}(BaseInfoComponent));
export { RoomInfoComponent };
